import { apiGet, apiPost, apiPatch, apiDelete } from '@/app/api/core/http';
import { createImage, updateImage } from '@/app/api/core/images';
import { CAT_EVENTS } from 'App/utils/Collections';
import { EVENTS_PATHS } from './paths';

export const eventsApiAdapter = {
  events: {
    get: (params, cat, headers) => {
      const { clearParams, ...rest } = params;
      let preparedParams = {
        params: rest,
        clearParams,
      };
      if (headers) {
        preparedParams.headers = headers;
      }
      return apiGet(EVENTS_PATHS.events + EVENTS_PATHS.suffix, preparedParams);
    },
    create: (data) => apiPost(EVENTS_PATHS.events, { data }),
    update: (id, data) => apiPatch(`${EVENTS_PATHS.events}/${id}`, { data }),
    getItem: (id, headers) => {
      if (headers) {
        return apiGet(`${EVENTS_PATHS.events}/${id}`, {
          headers: headers,
        });
      } else {
        return apiGet(`${EVENTS_PATHS.events}/${id}`);
      }
    },
    remove: (id) => apiDelete(`${EVENTS_PATHS.events}/${id}`),
  },
  eventTypes: {
    get: (params) => apiGet(EVENTS_PATHS.eventTypes, { params }),
    create: (data) => apiPost(EVENTS_PATHS.eventTypes, { data }),
    update: (id, data) => apiPatch(`${EVENTS_PATHS.eventTypes}/${id}`, { data }),
    getItem: (id) => apiGet(`${EVENTS_PATHS.eventTypes}/${id}`),
    remove: (id) => apiDelete(`${EVENTS_PATHS.eventTypes}/${id}`),
  },
  attendingRequests: {
    get: (params) => apiGet(EVENTS_PATHS.attendingRequests, { params }),
  },
  eventAtendingReports: {
    create: (data) => apiPost(EVENTS_PATHS.eventAtendingReports, { data }),
  },
  eventThemes: {
    get: (params) => apiGet(EVENTS_PATHS.eventThemes, { params }),
    getItem: (id) => apiGet(`${EVENTS_PATHS.eventThemes}/${id}`),
    create: (data) => apiPost(EVENTS_PATHS.eventThemes, { data }),
    update: (id, data) => apiPatch(`${EVENTS_PATHS.eventThemes}/${id}`, { data }),
    delete: (id) => apiDelete(`${EVENTS_PATHS.eventThemes}/${id}`),
  },
  eventImages: {
    create: (img, event_id, is_default = false, session_interval = 0) =>
      createImage(CAT_EVENTS, img, {
        event_id,
        is_logo: is_default,
        session_interval,
      }),
    update: (id, data) => updateImage(CAT_EVENTS, id, data),
    remove: (id) => apiDelete(`${EVENTS_PATHS.eventImages}/${id}`),
  },
  getEventImages: (event_id, params = {}) =>
    apiGet(EVENTS_PATHS.eventImages, {
      params: {
        ...params,
        'event.id': event_id,
      },
    }),
};
